import { BaseHttpController } from './BaseHttpController';

const endpoint = 'shipment-spec';

export class ShipmentSpecSpotMarketBatchController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async cancelSpotMarkets(shipmentSpecId: number): Promise<void> {
    await this.http.post<void>(`${shipmentSpecId}/spot-market/batch/cancel`);
  }
}
